import { Locales } from 'src/i18n'
import Translation from '../../shared/interfaces/Translation'
import PredefinedPeriodTranslationJson from './interfaces/PredefinedPeriodTranslationJson'

export default class PredefinedPeriodTranslation implements Translation {
  locale: Locales
  label: string

  constructor(locale: Locales, label: string) {
    this.locale = locale
    this.label = label
  }

  static fromJson(data: PredefinedPeriodTranslationJson) {
    return new this(data.locale, data.label)
  }
}
